module.exports = __webpack_public_path__ + "static/media/rasson-table.86e4ac1d.png";